import React from 'react';
import DataTable from 'react-data-table-component';
import { MenuComponent } from '../../assets/ts/components';

type Props = {
  data: any;
  columns: [];
  minHeight?: string;
};

const TableList: React.FC<Props> = ({ data, columns, minHeight = '550px' }) => {
  return (
    <>
      <DataTable
        columns={columns}
        data={data}
        expandableRowsHideExpander
        onChangePage={() => {
          MenuComponent.reinitialization();
        }}
        pagination
        responsive
        customStyles={{
          table: {
            style: {
              minHeight: minHeight,
            },
          },
          rows: {
            style: {
              borderBottom: '1px dashed #e4e6ef !important',
              paddingTop: '5px',
              paddingBottom: '5px',
            },
          },
          headRow: {
            style: {
              borderBottom: '1px dashed  #e4e6ef',
            },
          },
          pagination: {
            style: {
              borderTopStyle: 'none',
            },
          },
        }}
        paginationComponentOptions={{
          rowsPerPageText: 'Registros por página',
          rangeSeparatorText: 'de',
        }}
        noDataComponent={
          <>
            <div className="d-flex align-items-center">
              <div className="text-muted text-center fs-6 w-100 m-5">
                Sin registros
              </div>
            </div>
          </>
        }
        persistTableHead
      ></DataTable>
    </>
  );
};

export { TableList };
